import { Component } from '@angular/core';

@Component({
  selector: 'gmo-carousel',
  imports: [],
  templateUrl: './carousel.html',
  styleUrl: './carousel.scss',
})
export class Carousel {

}
